import { useFeatureFlags } from '@/contexts/FeatureFlagContext';

/**
 * Hook to check if a feature is enabled
 * 
 * @param featureName - The name of the feature to check
 * @returns boolean - true if feature is enabled, false otherwise
 * 
 * @example
 * const isNewDashboardEnabled = useFeature('newDashboard');
 * if (isNewDashboardEnabled) {
 *   // Render new dashboard
 * }
 */
export function useFeature(featureName: string): boolean {
  const { isFeatureEnabled } = useFeatureFlags();
  return isFeatureEnabled(featureName);
}
